import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref } from "vue"
import _imports_0 from '../assets/img/empty_img.png'


const _hoisted_1 = {
  key: 0,
  class: "ef-trainingPath__skeleton"
}
const _hoisted_2 = {
  key: 1,
  class: "ef-trainingPath"
}
const _hoisted_3 = { class: "ef-line" }
const _hoisted_4 = { class: "ef-trainingPath__content" }
const _hoisted_5 = { class: "ef-line ef-relative" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ef-trainingPath__dark" }, null, -1)
const _hoisted_9 = { class: "ef-trainingPath__title ef-absolute" }
const _hoisted_10 = { class: "ef-trainingPath__infos" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "ef-trainingPath__infosItem" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days" }, null, -1)

import Table from '@/components/Table.vue';

import {computed, ComputedRef, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import Header from '@/components/Header.vue';
import {storeTraining} from '@/stores/training';
import {AxiosResponse} from "axios";
import {getDuration} from "@/functions/utils";

//Router

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const _storeTraining = storeTraining();

//Data
const trainingPath = ref<any>();
const loading = ref(true);

const trainingsToDisplay: ComputedRef<Array<Object>> = computed(() => {
  if (trainingPath.value.trainings.length === 0) {
    return [{ id: 1, bubble: 'test', fields: [{title: 'title', value: 'value'}, {title: 'title', value: 'value'}, {title: 'title', value: 'value'}], actions: [{ icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' }] }];
  } else {
    let result = trainingPath.value.trainings;
    let actions = [
      { icon: 'fa-solid fa-eye', text: 'Voir', action: 'view' },
    ];
    return result.map((item: any) => {
      const fields = [
        { title: 'Titre', value: item.title },
        { title: "Heures", value: getDuration(item.eduDuration)  },
        { title: 'Catégories', value: item.categories  }
      ]
      return { id: item.id, img: item.img ? item.img : 'empty', fields: fields, actions: actions };
    });
  }
});

onMounted(() => {
  if (route.params.trainingPathId) {
    const trainingPathId = route.params.trainingPathId as string;
    _storeTraining.getTrainingPath(trainingPathId).then((response: AxiosResponse) => trainingPath.value = response);
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " loading "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Header, {
            icone: "fa-solid fa-user-graduate",
            title: trainingPath.value.title
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (trainingPath.value.imgUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "ef-trainingPath__img",
                  src: trainingPath.value.imgUrl,
                  alt: trainingPath.value.title
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "ef-trainingPath__img",
                  src: _imports_0,
                  alt: trainingPath.value.id
                }, null, 8, _hoisted_7)),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(trainingPath.value.title), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "ef-trainingPath__infosItem",
              style: {"font-style":"italic","font-size":"1.5rem"},
              innerHTML: trainingPath.value.description
            }, null, 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(_toDisplayString(new Date(trainingPath.value.creationDate).toLocaleString()) + "re ( ", 1)
            ])
          ]),
          _createVNode(Table, {
            items: _unref(trainingsToDisplay),
            numberItems: 0,
            loading: loading.value,
            onView: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/trainings/${$event}`)))
          }, null, 8, ["items", "loading"])
        ])
      ]))
}
}

})